import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { auth } from './firebase';

const ProfileSettings = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }

    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters.");
      return;
    }

    setIsUpdating(true);

    try {
      const user = auth.currentUser;
      
      // 1. Create a credential using their current password to prove who is at the keyboard
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      
      // 2. Re-authenticate the user securely
      await reauthenticateWithCredential(user, credential);
      
      // 3. Update the password
      await updatePassword(user, newPassword);

      setMessage("Password updated successfully!");
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      
      setTimeout(() => setMessage(''), 5000); // Clear success message after 5 seconds
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password') {
        setError("Current password is incorrect.");
      } else {
        setError("Failed to update password. Please try logging out and back in.");
      }
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '40px auto', backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontFamily: 'sans-serif' }}>
      <h2 style={{ margin: '0 0 20px 0', color: '#003366', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
        Security Settings
      </h2>
      
      {error && <div style={{ backgroundColor: '#ffe6e6', color: '#ba0c2f', padding: '10px', borderRadius: '4px', marginBottom: '20px', fontWeight: 'bold', fontSize: '14px' }}>{error}</div>}
      {message && <div style={{ backgroundColor: 'rgba(40, 167, 69, 0.1)', color: '#28a745', padding: '10px', borderRadius: '4px', marginBottom: '20px', fontWeight: 'bold', fontSize: '14px' }}>{message}</div>}

      <form onSubmit={handlePasswordChange} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px', color: '#333' }}>Current Password</label>
          <input 
            type="password" 
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            required
          />
        </div>

        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px', color: '#333' }}>New Password</label>
          <input 
            type="password" 
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            required
          />
        </div>

        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px', color: '#333' }}>Confirm New Password</label>
          <input 
            type="password" 
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            required
          />
        </div>

        <button 
          type="submit" 
          disabled={isUpdating}
          style={{ 
            backgroundColor: '#003366', 
            color: 'white', 
            border: 'none', 
            padding: '12px', 
            borderRadius: '4px', 
            fontWeight: 'bold', 
            cursor: isUpdating ? 'not-allowed' : 'pointer', 
            marginTop: '10px',
            opacity: isUpdating ? 0.7 : 1
          }}
        >
          {isUpdating ? 'Updating...' : 'Update Password'}
        </button>
      </form>
    </div>
  );
};

export default ProfileSettings;